import * as actionTypes from './actionTypes';
import { categories } from "../../data"
import {collections,documents} from "../../firebase/firestoreNameSpaces"
 import {firebase} from "../../firebase/index"
import { sortArrayObjects } from '../utility';
export const fetchCategories = () => {
    return async dispatch => {

        try{ 
            dispatch({ type: actionTypes.SIDEBAR_CATEGORY_LOADING, payload: { loading: true } })

            let categories = [];
            let db = firebase.firestore();
            let snapshot = await db.collection(collections.K5METADATA).doc(documents.CATEGORIES).get()
            let data = snapshot.data();
            for(let docKey in data){
                let category = data[docKey];
                let subcategory = [];
                if(category.subcategories){
                    for(let skey in category.subcategories){
                        subcategory.push({name:category.subcategories[skey],id:skey})
                    }
                    category.subcategories = subcategory;
                    subcategory = [];
                }
                categories.push(category)
                
            }
            categories = sortArrayObjects(categories,"categoryName")
            dispatch({ type: actionTypes.FETCH_SIDEBAR_CATEGORY, payload: { categories: categories, loading: false } })
        }catch(error){
            dispatch({ type: actionTypes.FETCH_SIDEBAR_CATEGORY, payload: { categories: [], loading: false } })
            return alert(error)
        }

    }
}  
export const fetchSingleCategory = (categoryId)=>{
//  console.log("CategoryId:----"+categoryId)
    return async (dispatch,getState) =>{
        try{
            dispatch({ type: actionTypes.SIDEBAR_CATEGORY_LOADING, payload: { loading: true } })
            let db = firebase.firestore();
            let categories = (await db.collection(collections.K5METADATA).doc(documents.CATEGORIES).get()).data()
            let category = categories[categoryId]
            if(category.subcategories){
                let subcategory = category.subcategories;
                let subcategories = [];
                    for(let sckey in subcategory){
                        subcategories.push({id:sckey,name:subcategory[sckey]})
                    }
                category.subcategories = sortArrayObjects(subcategories,"name");

                dispatch({ type: actionTypes.FETCH_SIDEBAR_CATEGORY, payload: { category: category, loading: false } })
            }else{
                dispatch({ type: actionTypes.FETCH_SIDEBAR_CATEGORY, payload: { category: {subcategories:[]}, loading: false } })
            }
                // let data = categories.filter(category=> category.id==categoryId)[0];
                
        
        }catch(error){
            dispatch({ type: actionTypes.FETCH_SIDEBAR_CATEGORY, payload: {category: {subcategories:[]}, loading: false } })
            return alert(error);
        }
       
    }
}
export const fetchShopCategory = ()=>{
    return async dispatch =>{
        try{
            dispatch({ type: actionTypes.SIDEBAR_CATEGORY_LOADING, payload: { loading: true } })
            let db = firebase.firestore();
            let snapshot =  await db.collection(collections.K5METADATA).doc(documents.SHOP).get()
            let subcategories = []
                let data = snapshot.data();
                if(data.subcategories){
                    for(let sk in data.subcategories){
                        subcategories.push({name:data.subcategories[sk],id:sk})
                    }
                    data.subcategories = sortArrayObjects(subcategories,"name")
                }else{
                    data.subcategories = []
                }
         dispatch({ type: actionTypes.FETCH_SIDEBAR_CATEGORY, payload: { category: data, loading: false } })
                
        }catch(error){
            dispatch({ type: actionTypes.FETCH_SIDEBAR_CATEGORY, payload: { category: null, loading: false } })
            return alert(error)
        }
    }
}
export const createCategory = (service,services)=>{
    
}